package app.bloomey.web.modules.auth

import app.bloomey.web.core.data.UiState
import com.copperleaf.ballast.InputHandler
import com.copperleaf.ballast.InputHandlerScope
import kotlinx.coroutines.flow.collectLatest

class AuthInputHandler : InputHandler<AuthContract.Inputs, AuthContract.Events, AuthContract.State> {

    private val repository = AuthRepository()
    override suspend fun InputHandlerScope<AuthContract.Inputs, AuthContract.Events, AuthContract.State>.handleInput(
        input: AuthContract.Inputs,
    ) {
        when (input) {
            is AuthContract.Inputs.Login -> {
                repository.login(input.email, input.password).collectLatest { loginState ->
                    updateState { AuthContract.State(loginState) }
                }
            }

            AuthContract.Inputs.ClearState -> {
                updateState { AuthContract.State(UiState.Initial) }
            }
        }
    }
}